@import '~style-sheet-helpers/core.less';
@import (reference) '../../../constants/spacing.module.less';
@import '../../../app-brand/entities/entity-layer.module.less';

.user-counts-container {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 75%;
}

.active-user-grid {
  border-collapse: collapse;
  border-radius: 8px;
  overflow: hidden;
  width: 100%;
  table-layout: fixed;

  tr {
    border: 1px solid var(--default--border-color--6);
  }

  th {
    padding: @space-16 @space-8;
    text-align: left;
    background: var(--default--background-color--4);
  }

  th:nth-child(1),
  td:nth-child(1) {
    width: 45%;
  }

  th:nth-child(2),
  td:nth-child(2) {
    width: 20%;
  }

  th:nth-child(3),
  td:nth-child(3) {
    width: 10%;
  }

  th:nth-child(4),
  td:nth-child(4) {
    width: 25%;
  }

  td {
    font-size: 14px;
    line-height: 24px;
    padding: @space-16 @space-8;
    text-align: left;
  }

  td:first-child {
    word-wrap: break-word;
    overflow-wrap: break-word;
  }

  th:last-child {
    text-align: center;
  }
  td:last-child {
    text-align: center;
  }
}

.button {
  padding: 0 @space-12;
  margin: 0;
}

.error-icon {
  width: 12px;
  margin-left: @space-8;
  color: var(--red-700);
}

.success-icon {
  width: 12px;
  margin-left: @space-8;
  color: var(--green-05B45E);
}

.modal-body {
  display: flex;
  padding: @space-16;
  flex-direction: column;
  align-items: flex-start;
  gap: @space-16;
}

.row-deactivated {
  background: var(--default--background-color--4);
}

.skip-button {
  margin-left: @space-8;
}
